<template>
    <v-container v-redirect-if-no-permission:SUGGESTION_ALLOWED_CAPTAIN>
        <v-flex xs12>
            <data-table :url="api.ACTIONS.SUGGESTION_ALLOWED_CAPTAIN"
                        title="Suggestion Allowed Captains"
                        :enable-edit="false"
                        :fields-extra-add="{captain_id: 'choose-captains-multi'}"
                        :fields-hidden-add="['id','created_at','updated_at','captain']"
                        :fields-hidden-main="['updated_at','captain_id','id']"
                        :input-types-add="{captain_id : {multi: false}}"
                        :formatter="formatter"

            />
        </v-flex>
    </v-container>

</template>

<script>
    import DataTable from "@/components/wasilni/DataTable";

    export default {
        name: "SuggestionAllowed",
        components: {DataTable},
        title: "Suggestion Allowed Captains",
        computed: {
            formatter() {
                return {
                    captain(val) {
                        if (!val)
                            return "";
                        return val.first_name + ' ' + val.last_name;
                    }
                };
            }
        }
    }
</script>

<style scoped>

</style>
